import React, { useEffect } from 'react';

export default (WrappedComponent) => {
  return (props) => {
    let isBlockInBlock = props.CurrentPageProps.CurrentPageProps !== undefined;

    const { currentActiveId, currentActiveMenuItem } = isBlockInBlock
      ? props.CurrentPageProps.CurrentPageProps
      : props.CurrentPageProps;

    useEffect(() => {
      if (
        props.CurrentPageProps.PageTypeName !== 'ReferencePage' && //Temp fix. ReferencePage should not render with anchor nav trigger.
        props.isInRange
      ) {
        if (
          props.AnchorSectionId &&
          currentActiveId !== props.AnchorSectionId
        ) {
          typeof currentActiveMenuItem === 'function' &&
            currentActiveMenuItem(props.AnchorSectionId);
        }
      }
    }, [props.isInRange]);

    return <WrappedComponent {...props} />;
  };
};
